import { useEffect } from "react";
import Button from "./Button";

export default function Modal({
  open,
  title,
  children,
  footer = null,
  size = "md",
  closeLabel = "Schließen",
  dismissable = true,
  onClose,
  testIdPrefix = "",
  onConfirm = null,
  okLabel,
  cancelLabel,
  danger = false,
  loading = false,
}) {
  const canDismiss = dismissable && !loading;

  useEffect(() => {
    if (!open) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape" && canDismiss) onClose();
    };

    const previousOverflowY = document.body.style.overflowY;
    document.addEventListener("keydown", closeOnEscape);
    document.body.style.overflowY = "hidden";

    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.body.style.overflowY = previousOverflowY;
    };
  }, [canDismiss, onClose, open]);

  if (!open) return null;

  const titleId = `${testIdPrefix}modal-title`;
  const footerContent = footer || (onConfirm && <>
    <Button variant="secondary" disabled={loading} onClick={onClose} data-testid={`${testIdPrefix}cancel-button`}>{cancelLabel}</Button>
    <Button variant={danger ? "danger" : "primary"} loading={loading} onClick={onConfirm} data-testid={`${testIdPrefix}confirm-button`}>
      {okLabel}
    </Button>
  </>);

  return (
    <>
      <div
        className={`peb-modal peb-modal--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        data-testid={`${testIdPrefix}modal`}
      >
        <div className="peb-modal__panel">
          <div className="peb-modal__header">
            <h5 className="peb-modal__title" id={titleId}>{title}</h5>
            <button
              type="button"
              className="peb-modal__close"
              aria-label={closeLabel}
              disabled={!canDismiss}
              onClick={onClose}
              data-testid={`${testIdPrefix}close-button`}
            >
              <span aria-hidden="true">✕</span>
            </button>
          </div>
          <div className="peb-modal__body">{children}</div>
          {footerContent && <div className="peb-modal__footer">{footerContent}</div>}
        </div>
      </div>
      <div
        className="peb-modal__backdrop"
        onClick={canDismiss ? onClose : undefined}
        data-testid={`${testIdPrefix}modal-backdrop`}
      />
    </>
  );
}
